<div class="item">
  <div class="ow-blog-post date-style-2">
    <div class="ow-post-media dez-img-effect zoom-slow"> <img style="height: 180px;" src="{{domain}}{{ image }}" alt="">
    </div>
    <div class="ow-post-info ">
      <div class="ow-post-title">
        <h6 class="post-title" style="text-align: justify"> <a routerLink="/noticia/{{id}}"
            title="">{{title|uppercase}}</a> </h6>
      </div>
      <div class="ow-post-meta">
        <ul>
          <li class="post-date"> <i class="fa fa-calendar"></i><strong>{{fecha_pub.day| number:'2.0-0'}}
              {{months[fecha_pub.month]}}</strong> <span> {{fecha_pub.year}}</span> </li>
        </ul>
      </div>


    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/components/news/news.component.html